import styled from '@emotion/styled';

export const StyledErrors = styled.div`
  color: #f44336;
`;
